import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import S from 'app/features/registrationPromo/components/Benefit.styled';
import Heading from 'app/components/layout/Heading.styled';

const Benefit = ({ titleId }) => (
  <S.Benefit data-t="benefit-available">
    <S.CheckMark />
    <Heading size="s" as={S.Title}>
      <FormattedMessage id={titleId} />
    </Heading>
  </S.Benefit>
);

Benefit.propTypes = {
  titleId: PropTypes.string.isRequired,
};

export default Benefit;
